module.exports = __webpack_public_path__ + "static/media/finish-checkout.7c92927b.png";